module.exports = __webpack_public_path__ + "static/media/icon_packaging.6c31ceaf.svg";